import React, {useEffect} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Slider from '@material-ui/core/Slider';
import $ from "jquery";

const useStyles = makeStyles({
  root: {
    width: 300,
  },
});

function valuetext(value) {
}

export default function AgeSlider(props) {

  
  const classes = useStyles();
  let range = [13,65];
  if(props.age_range){
    range = [props.age_range[0],props.age_range[1]];
  }
  const [value, setValue] = React.useState(range);

  //

  const handleChange = (event, newValue) => {
    setValue(newValue);
    props.onSliderChange(newValue);
   
  };

  return (
    
    
      <Slider
        value={value}
        onChange={handleChange}
        valueLabelDisplay="auto"
        aria-labelledby="range-slider"
        getAriaValueText={valuetext}
        min={props.start_age}
        max={props.end_age}
        direction="none" 
      />
     
   
  
  );
}